import { useLocation, useNavigate } from "react-router-dom";
import { ActionButton } from "../../components/Forms/ActionButton";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGetChallengeCategoriesList, useGetProposedChallengeDetails, useUpdateProposedChallenge } from "../../queries/challenge";
import Loader from "../../components/Common/Loader";
import { useForm } from "react-hook-form";
import MediaUpload from "../../components/Forms/MediaUpload";
import { useEffect, useState } from "react";

const EditProposedChallenge = () => {

    const { state: { proposedChallengeId } } = useLocation();
    const navigate = useNavigate();

    // Proposed Challenge Details
    const { data, isPending, isError } = useGetProposedChallengeDetails(proposedChallengeId);
    // Challenge Category List
    const { data: categoryData, isPending: isCategoryPending } = useGetChallengeCategoriesList();

    const { mutateAsync: updateChallenge, isPending: isUpdatingChallenge } = useUpdateProposedChallenge(proposedChallengeId);

    const [stateCoverImage, setStateCoverImage] = useState(null);
    const [coverImage, setCoverImage] = useState(data?.sampleMedia[0] || "");

    const { register, handleSubmit, formState } = useForm();

    const onSubmit = (data) => {
        data._id = proposedChallengeId;
        if(stateCoverImage) {
            data.sampleMedia = coverImage;
        }
        console.log(data);
        updateChallenge(data, {
            onSuccess: () => {
                toast.success("Proposed Challenge updated successfully!");
                setTimeout(() => {
                    navigate("/challenges/proposed-challenges-details", { state: { proposedChallengeId: proposedChallengeId } });
                }, 2000);
            },
            onError: (error) => {
                toast.error("Failed to update the proposed challenge.");
                console.error(error);
            },
        });
    };
    
    useEffect(() => {
        setCoverImage(data?.sampleMedia[0]);
    }, [data]);
    
    if (isPending) {
        return <Loader />;
    }

    if (isError) {
        return <div className="text-center mt-10">Error loading proposed challenge details.</div>;
    }

    return (
        <div className="flex flex-col text-base font-semibold text-gray-900 rounded ">
            <div className="bg-white rounded shadow-[0px_0px_25px_rgba(94,92,154,0.1)]  p-5">
                <div className="flex justify-between items-center">
                    <h1
                        className="gap-2.5 w-full text-xl font-bold max-md:max-w-full text-primary capitalize cursor-pointer"
                    >
                        Proposed Challenge Edit
                    </h1>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <div>
                        <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-2">
                            <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">
                                {"Challenge Name"}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="text"
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base`}
                                    placeholder="Challenge Name"
                                    name="name"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("name", {
                                        required: "Challenge Name is required",
                                        value: data?.name,
                                    })}
                                />
                            </div>
                        </div>
                        <div className="flex flex-row flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-1 gap-3">
                            <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-2">
                                <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">
                                    {"Challenge Category"}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <select
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base`}
                                        name="category"
                                        {...register("category")}
                                        defaultValue={!isCategoryPending && data?.category?._id}
                                    >
                                        {
                                            !isCategoryPending && categoryData?.map((category) => (
                                                <option value={category._id} key={category._id}>
                                                    {category.name}
                                                </option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-2">
                                <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">
                                    {"Proposed By"}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base`}
                                        placeholder="Proposed By"
                                        name="name"
                                        onWheel={(e) => e.target.blur()}
                                        {...register("proposedByUser", {
                                            required: "Proposed by user is required",
                                            value: data?.proposedByUser?.userName,
                                        })}
                                        value={data && data?.proposedByUser?.userName}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-2 gap-3">
                            <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-2">
                                <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">
                                    {"Challenge Description"}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <textarea
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base`}
                                        placeholder="Challenge Description"
                                        name="name"
                                        onWheel={(e) => e.target.blur()}
                                        {...register("description", {
                                            required: "Challenge Description is required",
                                            value: data?.description,
                                        })}
                                        defaultValue={data?.description}
                                        rows={5}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-1">
                                <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">
                                    {"Inspire Me"}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <textarea
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base`}
                                        placeholder="Inspire Me"
                                        name="name"
                                        onWheel={(e) => e.target.blur()}
                                        {...register("inspireMe", {
                                            required: "Inspire Me is required",
                                            value: data?.inspireMe,
                                        })}
                                        defaultValue={data?.inspireMe}
                                        rows={5}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <MediaUpload
                        label="Challenge Media"
                        name="sampleMedia"
                        setImageUpload={setCoverImage}
                        existingImage={coverImage}
                        stateImage={stateCoverImage}
                        setStateImageUpload={setStateCoverImage}
                        className={'mt-5'}
                    />
                    
                    <div className="mt-5 flex justify-end gap-3">
                        <ActionButton
                            variant="cancel"
                            className="bg-primary text-white font-semibold py-2 px-4 rounded mt-5"
                            text={'Cancel'}
                            disabled={isUpdatingChallenge}
                            handleSubmit={() => window.history.back()}
                        />
                        <ActionButton
                            variant="submit"
                            className="bg-primary text-white font-semibold py-2 px-4 rounded mt-5"
                            text={'Update Proposal'}
                            disabled={isUpdatingChallenge}
                        />
                    </div>
                </form>
            </div>
            <ToastContainer
                position="top-right"
            />
        </div>
    );
}

export default EditProposedChallenge;